import React, { Fragment, useState } from 'react'
import estilos from './ZonasComponent.module.css'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { insertDiasDeAlmacen, insertDiasDeProduccion, insertDiasDeEnvasado } from '../../../redux/DucksUnidadInspeccion/DiasDeAtencionDuck'
import { useDispatch } from 'react-redux'


function DiasDeLaLocalidadComponent(props) {


        const dispatch = useDispatch()
        const idUnidadProduccionUbicacion = props.idUnidadProduccionUbicacion
        const isLocalidad = props.isLocalidad

        const [lunes, setLunes] = React.useState(false);
        const [martes, setMartes] = React.useState(false);
        const [miercoles, setMiercoles] = React.useState(false);
        const [jueves, setJueves] = React.useState(false);
        const [viernes, setViernes] = React.useState(false);

        const [diasDeAtencionModify, setdiasDeAtencionModify] = React.useState(null)

        const [inicialStateFormik, setInicialStateFormik] = useState(
                { lunes: lunes, martes: martes, miercoles: miercoles, jueves: jueves, viernes: viernes })

        const guardarDiasDeAtencion = () => {
                dispatch(eliminarLocalidad(data))
        }

        React.useState(() => {
                if (diasDeAtencionModify !== null) {
                        setInicialStateFormik({
                                lunes: diasDeAtencionModify.lunes,
                                martes: diasDeAtencionModify.martes,
                                miercoles: diasDeAtencionModify.miercoles,
                                jueves: diasDeAtencionModify.jueves,
                                viernes: diasDeAtencionModify.viernes,
                        })
                }
        }, [diasDeAtencionModify])


        const imprimirDiasSeleccionados = (data) => {

                alert(JSON.stringify(data))

        }



        return (
                <Fragment>

                        {
                                isLocalidad === true ? (
                                        <Formik initialValues={inicialStateFormik} bvalidate={values => { const errors = {}; return errors; }}
                                                onSubmit={(values, { setSubmitting }) => {
                                                        if (diasDeAtencionModify) {
                                                                const data = {
                                                                        data: {
                                                                                idUnidadProduccionUbicacion: diasDeAtencionModify.idUnidadProduccionUbicacion,
                                                                                lunes: diasDeAtencionModify.lunes,
                                                                                martes: diasDeAtencionModify.martes,
                                                                                miercoles: diasDeAtencionModify.miercoles,
                                                                                jueves: diasDeAtencionModify.jueves,
                                                                                viernes: diasDeAtencionModify.viernes,
                                                                        }
                                                                }
                                                                //imprimirDiasSeleccionados(data)
                                                                dispatch(updateDiasDeAlmacen(data))

                                                        } else {
                                                                const data = {
                                                                        data: {
                                                                                idUnidadProduccionUbicacion: idUnidadProduccionUbicacion,
                                                                                lunes: values.lunes,
                                                                                martes: values.martes,
                                                                                miercoles: values.miercoles,
                                                                                jueves: values.jueves,
                                                                                viernes: values.viernes,
                                                                        }
                                                                }

                                                                //imprimirDiasSeleccionados(data)
                                                                dispatch(insertDiasDeAlmacen(data))
                                                        }
                                                        setSubmitting(false);
                                                        props.onClose()
                                                }}
                                        >
                                                {({ isSubmitting }) => (
                                                        <Form>
                                                                <h4 className={`${estilos.tituloForm}`}><strong>Seleccione los días:</strong></h4>
                                                                <div scope="row" className={`${estilos.zoom} text-center`} >
                                                                        <hr />
                                                                        <div className={`alert alert-success ${estilos.alertItem}`} role="alert" >
                                                                                <div className='row'>
                                                                                        <div className='col-12'>
                                                                                                <p><strong>(Únicamente puede seleccionar 3 días)</strong></p>
                                                                                                <div className='form-check form-check-inline'>
                                                                                                        <Field type="checkbox" name="lunes" className='form-check-input' />
                                                                                                        <h5>Lunes</h5>
                                                                                                </div>
                                                                                                <div className='form-check form-check-inline'>
                                                                                                        <Field type="checkbox" name="martes" className='form-check-input' />
                                                                                                        <h5>Martes</h5>
                                                                                                </div>
                                                                                                <div className='form-check form-check-inline'>
                                                                                                        <Field type="checkbox" name="miercoles" className='form-check-input' />
                                                                                                        <h5>Miercoles</h5>
                                                                                                </div>
                                                                                                <div className='form-check form-check-inline'>
                                                                                                        <Field type="checkbox" name="jueves" className='form-check-input' />
                                                                                                        <h5>Jueves</h5>
                                                                                                </div>
                                                                                                <div className='form-check form-check-inline'>
                                                                                                        <Field type="checkbox" name="viernes" className='form-check-input' />
                                                                                                        <h5>Viernes</h5>
                                                                                                </div>
                                                                                        </div>
                                                                                </div>
                                                                        </div>
                                                                        <button className='btn btn-success'>Aceptar</button>
                                                                </div>
                                                        </Form>
                                                )}
                                        </Formik>
                                ) :

                                        (<></>)
                        }




                </Fragment>
        )
}

export default DiasDeLaLocalidadComponent